import React from 'react';
import PropTypes from 'prop-types';

import SectionTitle from 'components/checkout/melody/SectionTitle';
import css from 'styles/containers/checkout/melody/review.scss';

export const Review = ({ reviewSection }, { testId = f => f }) => (
  <ul className={css.section} data-test-id={testId('review')}>
    <li><SectionTitle
      id="review-section"
      isComplete={true}
      step="4"
      title="Review Items" /></li>
    <li></li>
    <li>{ reviewSection }</li>
  </ul>
);

Review.contextTypes = {
  testId: PropTypes.func
};

export default Review;
